import { HttpContextToken } from '@angular/common/http';

/**
 * Context token para omitir el manejo automático de errores en el interceptor
 *
 * @remarks
 * Cuando este token está en true, el InterceptorService NO mostrará el modal
 * de error automático, permitiendo que el servicio consumidor maneje el error
 * con su propia lógica en el catchError.
 *
 * @example
 * ```typescript
 * // En el HttpService
 * const context = new HttpContext().set(SKIP_ERROR_HANDLING, true);
 * this.http.get('/api/endpoint', { context });
 *
 * // El interceptor leerá este token y omitirá el displayError()
 * ```
 */
export const SKIP_ERROR_HANDLING = new HttpContextToken<boolean>(() => false);
